import React from 'react';
import { NotificationCard } from 'core/components/notification-card';
import { actions } from 'tools/tasks/offer-actions/offer-override-actions/offer-actions';

const WarningCard = ({ name, action }) => {
  if (name !== 'Offer Overrides') {
    return null;
  }

  const warning = actions.find((a) => a.id === action)?.warning;

  if (!warning || !warning?.length) {
    return null;
  }

  return <NotificationCard>{warning}</NotificationCard>;
};

export default WarningCard;
